export const initialState = {
  message: '',
  scheduledAt: null,
};
